import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { useMantineTheme, Text, Input, Divider, Group, ActionIcon } from '@mantine/core';
import { IconTrash, IconPlus, IconPrinter } from '@tabler/icons-react';
import { PDFDownloadLink } from '@react-pdf/renderer';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputComponent from "../../components/general/InputComponent";

import PrintLabel from "../../components/utilities/PrintLabel";

const BarangKelengkapan = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'barangKelengkapan-1',
        errorDeleteData: 'barangKelengkapan-2',
    })

    const [data, setData] = React.useState({
        submitLoading: false,
        modalShow: false,
        modalValue: '',
        modalValueError: '',

        deleteLoading: false,
        deleteModal: false,
        deleteKelengkapanName: '',
        deleteKelengkapanId: '',

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = () => {
        setData(d => ({ ...d, modalValueError: '' }));

        if (validator.isEmpty(data.modalValue, { ignore_whitespace: true })) {
            setData(d => ({ ...d, modalValueError: 'Kelengkapan barang wajib diisi!' }));
        } else {

            setData(d => ({ ...d, submitLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('project_id', stateData.projectId);
            formDT.append('project_process', stateData.projectProcess);
            formDT.append('project_is_cancel', stateData.projectIsCancel);
            formDT.append('project_barang_kelengkapan', data.modalValue);

            axios({
                method: 'post',
                url: BE_API_TWO + '/edit_project_barang_kelengkapan',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false, modalShow: false }));

                if (response.data.flag_status === 'isset') {
                    setData(d => ({ ...d, modalValue: '' }))
                    fnOnChange(response.data.data);
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    submitLoading: false,
                    modalShow: false
                }))

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    const deleteData = () => {
        setData(d => ({ ...d, deleteLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_barang_kelengkapan_id', data.deleteKelengkapanId);

        axios({
            method: 'post',
            url: BE_API_TWO + '/delete_project_barang_kelengkapan',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false, deleteModal: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(response.data.data);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorDeleteData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                deleteLoading: false,
                deleteModal: false
            }))

            notifications.show({
                id: notificationId.current.errorDeleteData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const handleCreatePDF = (e, url) => {
        e.preventDefault();
        window.open(url);
    }

    return (
        <React.Fragment>
            <Input.Wrapper
                id={stateData.data.id}
                withAsterisk={stateData.data.withAsterisk}
                styles={(tema) => ({ label: { width: '100%' } })}
                label={
                    <Group position='apart' mb='.5rem'>
                        <Text>{stateData.data.label}</Text>

                        <PDFDownloadLink
                            document={
                                <PrintLabel
                                    stateData={{
                                        projectId: stateData.projectId,
                                        kelengkapan: stateData.data.value,
                                        barangNama: stateData.barangNama,
                                        kerusakan: stateData.kerusakan,
                                        customer: stateData.customer,
                                        tanggalMasuk: stateData.tanggalMasuk
                                    }}
                                />
                            }
                            fileName={`label_.pdf`}
                            style={{ textDecoration: 'none' }}
                        >
                            {({ blob, url, loading, error }) =>
                                <ActionIcon
                                    size='md'
                                    variant="light"
                                    color="blue"
                                    radius='xl'
                                    onClick={(e) => handleCreatePDF(e, url)}
                                >
                                    <IconPrinter size='1rem' />
                                </ActionIcon>
                            }
                        </PDFDownloadLink>
                    </Group>
                }
                description={stateData.data.description}
            >
                {Array.isArray(stateData.data.value) && Object.keys(stateData.data.value).map((key, index) => {
                    return (
                        <React.Fragment key={key}>
                            <Group
                                position="apart"
                                noWrap
                                align='flex-start'
                                mt='xs'
                                mb='sm'
                            >
                                <Group noWrap align="flex-start" spacing={5}>
                                    <Text size='sm'>{Number(index) + 1}.</Text>
                                    <Text size='sm'>{stateData.data.value[key].kelengkapan_barang_nama}</Text>
                                </Group>

                                <ActionIcon
                                    size='md'
                                    variant="subtle"
                                    color="red"
                                    radius='xl'
                                    onClick={() => setData(d => ({
                                        ...d,
                                        deleteKelengkapanName: stateData.data.value[key].kelengkapan_barang_nama,
                                        deleteKelengkapanId: stateData.data.value[key].kelengkapan_barang_id,
                                        deleteModal: true
                                    }))}
                                >
                                    <IconTrash size='1rem' />
                                </ActionIcon>
                            </Group>

                            {(Number(index) + 1) !== stateData.data.value.length && <Divider />}
                        </React.Fragment>
                    )
                })}
            </Input.Wrapper>

            {stateData.data.error &&
                <Text
                    c={theme.colorScheme === 'light' ? theme.colors.red[6] : theme.colors.red[8]}
                    size={theme.fontSizes.xs}
                    my='.35rem'
                >
                    {stateData.data.error}
                </Text>
            }

            <Group
                spacing={5}
                px='xs'
                py='0.25rem'
                mt='md'
                position="center"

                sx={(tema) => ({
                    borderWidth: '1px',
                    borderStyle: 'dashed',
                    borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                    borderRadius: tema.radius.sm,
                    color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                    }
                })}

                onClick={() => setData(d => ({ ...d, modalShow: true }))}
            >
                <IconPlus size='0.8rem' />
                <Text size='sm'>Tambah Kelengkapan</Text>
            </Group>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.modalShow}
                fnHide={() => setData(d => ({ ...d, modalShow: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Kelengkapan Barang').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.submitLoading}
                fnButtonAction={submitData}
            >
                <InputComponent
                    stateId='barangKelengkapanModalInput-1'
                    stateWithAsterisk={false}
                    stateLabel=''
                    stateDescription=''
                    statePlaceHolder='Contoh: Tas Laptop'
                    stateReadOnly={false}
                    stateValue={data.modalValue}
                    stateError={data.modalValueError}

                    fnOnChange={(e) => setData(d => ({ ...d, modalValue: e.target.value }))}
                />
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.deleteModal}
                fnHide={() => setData(d => ({ ...d, deleteModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Kelengkapan Barang').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.deleteLoading}
                fnButtonAction={deleteData}
            >
                <Text size='sm'>
                    Hapus "{data.deleteKelengkapanName}" ?
                </Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default BarangKelengkapan;